// @ts-nocheck
import React from "react";
import ChatBot from "react-simple-chatbot";
import FetchAnswer from "./FetchAnswer";

const ChatComponent = () => {
 localStorage.clear()
  const steps = [
    { id: "1", message: "¡Hola! voy ayudarte a seleccionar un personal, por favor seleccion un tipo de perfil", trigger: "optionsProfile" },
    { 
      id: "optionsProfile",
      options: [
        { value: "Abogado", label: "Abogado", trigger: "indicateQuestion" },
        { value: "Arquitecto", label: "Arquitecto", trigger: "indicateQuestion" },
        { value: "all", label: "Todos", trigger: "indicateQuestionAll" },
        { value: "custom", label: "Perfil específico", trigger: "indicateProfile" }
      ] 
    },
    { id: "indicateQuestion", message: "Escriba la pregunta acerca del perfil: {previousValue}", trigger: "userInputQuestion"},
    { id: "indicateQuestionAll", message: "Escriba su pregunta", trigger: "userInputQuestion"},
    { id: "indicateProfile", message: "Escriba el nombre el perfil", trigger: "userInputProfile"},
    { id: "userInputProfile", user: true, trigger: "indicateQuestion" },
    { id: "userInputQuestion", user: true, trigger: "fetchCustom" },
    { id: "fetchCustom", component: <FetchAnswer />, asMessage: true, trigger: "userInputQuestion", waitAction:true },
  ];

  return (
    <ChatBot
      steps={steps}
      userDelay={500}
      placeholder="Escribe el mensaje"
      headerTitle="Caleidos Chatboot"
    />
  );
};

export default ChatComponent;
